import { useQuery, UseQueryResult } from 'react-query';
import { DrillDownDto } from '../../../services/dtos/riskProducts/drillDown.dto';
import { fetchDrillDown } from '../../../services/riskProducts/riskProducts.service';
import { queryKeys } from '../../queryKeyFactory';

export default (companies: number[]): UseQueryResult<DrillDownDto[], Error> => {
  return useQuery<DrillDownDto[], Error>(queryKeys.fetchRiskProducts.dashboard.drillDown(companies), async () => {
    const data = await fetchDrillDown(companies);
    return data;
  });
};
